
export const ITEMS_BY_ROW = 2;
export const GRID_COLS = 12;
// Default size of items
export const NCOLS = GRID_COLS / ITEMS_BY_ROW;
export const NROWS = 8;
export const ROW_HEIGHT = 30;
export const WIDTH = 1200;
// Responsive default variables
export const BREAKPOINTS = {lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0};
export const GRID_COLS_RESPONSIVE = {lg: 12, md: 10, sm: 6, xs: 4, xxs: 2};
// export const ITEMS_BY_ROW_RESPONSIVE = {lg: 2, md: 2, sm: 2, xs: 1, xxs: 1};
export const NCOLS_RESPONSIVE = {lg: 6, md: 5, sm: 3, xs: 4, xxs: 2};